export const insights = [
  {
    title: "What businesses should know before signing a commercial agreement",
    category: "Corporate",
    date: "12 Sep 2026",
    readTime: "6 min read",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/f00d2e1a-ce92-4597-81da-13fbc9fc163d.jpg",
    alt: "Hands reviewing a printed commercial agreement on a stone desk",
  },
  {
    title: "Resolving property disputes before they become litigation",
    category: "Property",
    date: "28 Aug 2026",
    readTime: "5 min read",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/18a13e3d-5a77-46f9-992f-042370026fbc.jpg",
    alt: "Facade of a modern British residential building",
  },
  {
    title: "Five compliance risks growing businesses often overlook",
    category: "Advisory",
    date: "14 Aug 2026",
    readTime: "7 min read",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/afceb3e4-3eb5-4e58-b819-53df777eb954.jpg",
    alt: "A legal advisor in conversation with a business owner by a window",
  },
];
